{"USE_ANSIBLE_VARS":"true","BUILD_CONFIG":"production","VERSION":"d20715f6149dcbf04bb6a9772cc54ef60a2b407e"}